export enum VerificationEnum {
    USERS = 'USERS',
    DOCUMENTS = 'DOCUMENTS',
}

export enum VerificationActionEnum {
    DENY = 'DENY',
    APPROVE = 'APPROVE',
}
